<div class="p-4 md:p-6 bg-white font-sans text-gray-800 flex flex-col h-full max-h-[90vh] rounded-xl">
  <!-- Header -->
  <div class="flex justify-between items-center border-b border-gray-100 pb-5 mb-6">
    <div class="flex items-center gap-4">
      <div class="w-12 h-12 rounded-full bg-red-50 flex items-center justify-center border border-red-100 shrink-0">
        <i class="fa fa-reply text-red-500 text-xl"></i>
      </div>
      <div>
        <h2 class="text-xl font-bold text-gray-900 m-0 leading-tight">
          Retour &amp; Avoir
        </h2>
        <div class="flex items-center gap-2 mt-1">
          <!-- Order ID Badge with Tooltip -->
          <div class="financial-tooltip-group">
            <span class="bg-gray-100 text-gray-600 text-[10px] md:text-xs px-2 py-0.5 rounded font-bold cursor-help flex items-center gap-1.5 hover:bg-gray-200 transition-colors border border-gray-200">
              Commande #{{ order.id }}
              <i class="fas fa-info-circle text-[10px] text-blue-400"></i>
            </span>
            
            <!-- Tooltip Card -->
            <div class="finance-tooltip-card">
              <div class="flex flex-col gap-2">
                <div class="flex justify-between items-center text-[10px] uppercase font-black tracking-widest text-gray-400 mb-1 border-b border-gray-100 pb-1">
                  <span>Finance</span>
                  <span [class]="isOrderPaid(order) ? 'text-emerald-500' : 'text-red-500'">
                    {{ isOrderPaid(order) ? 'Payée' : 'Impayée' }}
                  </span>
                </div>
                <div class="flex justify-between text-xs">
                  <span class="text-gray-500">Sous-total:</span>
                  <span class="font-bold">MAD {{ (order.total || 0) | number:'1.2-2' }}</span>
                </div>
                <div class="flex justify-between text-xs" *ngIf="(order.discount || 0) > 0">
                  <span class="text-gray-500">Réduction:</span>
                  <span class="font-bold text-emerald-600">-MAD {{ (order.discount || 0) | number:'1.2-2' }}</span>
                </div>
                <div class="flex justify-between text-xs pt-1 border-t border-gray-50 font-bold">
                  <span>Total Net:</span>
                  <span>MAD {{ ((order.total || 0) - (order.discount || 0)) | number:'1.2-2' }}</span>
                </div>
                <div class="flex justify-between text-xs">
                  <span class="text-gray-500">Avance:</span>
                  <span class="font-bold text-blue-600">MAD {{ (order.advancePayment || 0) | number:'1.2-2' }}</span>
                </div>
                <div class="flex justify-between items-center p-2 rounded bg-gray-50 mt-1">
                  <span class="text-[9px] font-bold uppercase text-gray-500">Reste à payer:</span>
                  <span class="text-xs font-black" [class.text-red-600]="orderDebt > 0">{{ orderDebt | number:'1.2-2' }} MAD</span>
                </div>
              </div>
              <div class="absolute -top-1 left-4 w-2 h-2 bg-white border-t border-l border-gray-200 transform rotate-45"></div>
            </div>
          </div>

          <!-- Date Badge -->
          <span class="text-gray-400 text-xs flex items-center">
            <i class="far fa-calendar-alt mr-1"></i> 
            {{ order.orderDate | date:'dd/MM/yyyy' }}
          </span>
        </div>
      </div>
    </div>

    <!-- Select All Toggle Button -->
    <button *ngIf="hasAnyReturnable" type="button" class="select-all-btn" 
            [class.active]="isAllSelected"
            (click)="isAllSelected ? clearAll() : selectAllReturnable()">
      <i [class]="isAllSelected ? 'fa fa-times-circle' : 'fa fa-check-double'"></i>
      <span>{{ isAllSelected ? 'Réinitialiser' : 'Avoir complet' }}</span>
    </button>
  </div>

  <!-- Content -->
  <div class="flex-1 overflow-y-auto pr-2" [formGroup]="returnForm">
    <!-- Products Table -->
    <div class="bg-white border border-gray-200 rounded-lg shadow-sm mb-6 w-full overflow-x-auto">
      <table class="w-full text-left border-collapse min-w-[650px] md:min-w-full">
        <thead class="bg-gray-50 border-b border-gray-200">
          <tr>
            <th class="py-3 px-2 md:px-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Produit</th>
            <th class="py-3 px-2 md:px-3 text-xs font-semibold text-gray-500 uppercase tracking-wider text-right">Prix</th>
            <th class="py-3 px-2 md:px-3 text-xs font-semibold text-gray-500 uppercase tracking-wider text-center">Qté Initiale</th>
            <th class="py-3 px-2 md:px-3 text-xs font-semibold text-gray-500 uppercase tracking-wider text-center">Déjà Retourné</th>
            <th class="py-3 px-2 md:px-3 text-xs font-semibold text-red-500 uppercase tracking-wider text-center">À Retourner</th>
            <th class="py-3 px-2 md:px-3 text-xs font-semibold text-gray-500 uppercase tracking-wider text-center" title="Article défectueux (non remis en stock)">Défectueux</th>
            <th class="py-3 px-2 md:px-3 text-xs font-semibold text-gray-500 uppercase tracking-wider text-right">Total (MAD)</th>
          </tr>
        </thead>
        <tbody formArrayName="lines" class="divide-y divide-gray-100">
          <tr *ngFor="let control of lines.controls; let i = index" [formGroupName]="i" class="hover:bg-gray-50 transition-colors">
            <td class="py-3 px-2 md:px-3">
              <span class="font-medium text-gray-900 block truncate max-w-[150px] md:max-w-[200px]" [title]="control.get('product')?.value?.name">
                {{ control.get('product')?.value?.name }}
              </span>
            </td>
            <td class="py-3 px-2 md:px-3 text-right text-gray-600 font-medium">
              {{ control.get('price')?.value | number:'1.2-2' }}
            </td>
            <td class="py-3 px-2 md:px-3 text-center text-gray-500">
              {{ control.get('originalQuantity')?.value }}
            </td>
            <td class="py-3 px-2 md:px-3 text-center">
              <span *ngIf="control.get('previouslyReturned')?.value > 0" class="inline-flex items-center justify-center bg-orange-100 text-orange-700 text-xs font-bold px-2 py-1 rounded-full">
                {{ control.get('previouslyReturned')?.value }}
              </span>
              <span *ngIf="!(control.get('previouslyReturned')?.value > 0)" class="text-gray-400">-</span>
            </td>
            <td class="py-3 px-2 md:px-3 text-center">
              <div class="relative inline-block w-20 md:w-24">
                <input type="number" 
                       class="w-full text-center py-1.5 px-1 md:px-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-shadow outline-none text-gray-900 font-semibold" 
                       formControlName="quantityReturned" 
                       min="0" 
                       [max]="control.get('maxReturnable')?.value"
                       [class.border-red-500]="control.get('quantityReturned')?.invalid && control.get('quantityReturned')?.touched">
                <div class="absolute -bottom-4 left-0 w-full text-center text-[10px] text-red-500 font-medium" *ngIf="control.get('quantityReturned')?.hasError('max')">
                  Max: {{ control.get('maxReturnable')?.value }}
                </div>
              </div>
            </td>
            <td class="py-3 px-2 md:px-3 text-center">
              <label class="relative inline-flex items-center cursor-pointer justify-center" [class.opacity-50]="control.get('quantityReturned')?.value <= 0">
                <input type="checkbox" formControlName="isDefective" class="sr-only peer" [disabled]="control.get('quantityReturned')?.value <= 0">
                <div class="w-9 h-5 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-orange-500"></div>
              </label>
            </td>
            <td class="py-3 px-2 md:px-3 text-right font-bold text-gray-900">
              {{ (control.get('quantityReturned')?.value * control.get('price')?.value) || 0 | number:'1.2-2' }}
            </td>
          </tr>
        </tbody>
        <!-- Brilliant Invoice-Style Footer for Adjustments -->
        <tfoot *ngIf="(order.discount ?? 0) > 0" class="bg-slate-50/50 border-t-2 border-gray-200">
          <tr>
            <td colspan="4" class="py-4 px-3 text-right">
              <div class="flex items-center justify-end gap-2 text-slate-500 font-bold text-[10px] uppercase tracking-widest">
                <i class="fa fa-tag text-blue-500"></i>
                Réduction Initiale ({{ order.discount | number:'1.2-2' }} MAD) — Ajuster à déduire :
              </div>
            </td>
            <td class="py-4 px-3 text-center">
              <div class="compact-input-group mx-auto">
                <input type="number" formControlName="discountAdjustment" class="compact-input" placeholder="0">
                <button type="button" class="btn-max" (click)="applyFullDiscountAdjustment()" title="Tout déduire">MAX</button>
              </div>
            </td>
            <td></td>
            <td class="py-4 px-3 text-right font-black text-red-600">
              - {{ returnForm.get('discountAdjustment')?.value | number:'1.2-2' }}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>

    <!-- Notes field -->
    <div class="mt-6 mb-5">
      <label for="notes" class="notes-label">Notes / Motif du retour (Optionnel)</label>
      <textarea id="notes" 
                formControlName="notes" 
                rows="2" 
                class="notes-input" 
                placeholder="Détaillez la raison du retour ou l'état des produits..."></textarea>
    </div>

    <!-- Clean Status Banner -->
    <div class="status-banner"
         [class.banner-success]="isCashSufficient && totalRefundAmount > 0"
         [class.banner-warning]="!isCashSufficient && totalRefundAmount > 0">

      <div class="banner-left">
        <span class="banner-dot"
              [class.dot-success]="isCashSufficient"
              [class.dot-warning]="!isCashSufficient"></span>
        <div class="banner-text">
          <span class="banner-title">
            {{ !isCashSufficient ? 'File d\'Attente — Cash Insuffisant' : 'Remboursement Immédiat' }}
          </span>
          <span class="banner-sub"
                [style.visibility]="!isCashSufficient ? 'visible' : 'hidden'">
            L'avoir sera mis en "Prêt à valider" quand la caisse disposera du cash
          </span>
        </div>
      </div>

      <div class="banner-cash">
        <span class="cash-number">{{ currentCash | number:'1.2-2' }}</span>
        <span class="cash-unit">MAD</span>
      </div>

    </div>

  </div>

  <!-- Summary Footer (Amount + Actions) -->
  <div class="summary-footer">
    <!-- Left: Detailed Amount Breakdown -->
    <div class="summary-amount-block flex flex-col gap-1">
      <!-- 1. Gross Return (Net of discount adjustment) -->
      <div class="flex items-center gap-2 text-xs text-gray-500 font-medium">
        <span>Valeur Nette du Retour:</span>
        <span class="font-bold text-gray-700">{{ netRefundAmount | number:'1.2-2' }} MAD</span>
      </div>

      <!-- 2. Debt Absorption (Show only if applicable) -->
      <div *ngIf="orderDebt > 0" class="flex items-center gap-2 text-xs text-blue-600 font-medium animate-in fade-in duration-300">
        <i class="fa fa-minus-circle text-[10px]"></i>
        <span>Absorbé par Dette ({{ orderDebt | number:'1.2-2' }} MAD restants):</span>
        <span class="font-bold">- {{ amountAbsorbedFromDebt | number:'1.2-2' }} MAD</span>
      </div>

      <!-- 3. Final Cash Amount -->
      <div class="flex flex-col mt-1">
        <span class="summary-label text-red-500 font-black uppercase text-[10px] tracking-wider">Total à Restituer (Cash)</span>
        <div class="summary-amount flex items-baseline">
          <span class="amount-big text-3xl font-black text-red-600 tracking-tight">{{ finalCashRefund | number:'1.2-2' }}</span>
          <span class="amount-unit text-lg font-bold text-red-600 ml-1">MAD</span>
        </div>
      </div>
    </div>

    <!-- Right: Actions -->
    <div class="summary-actions">
      <button type="button" class="btn-cancel" (click)="cancel()" [disabled]="isSubmitting">
        Annuler
      </button>
      <button type="button" class="btn-submit" 
              (click)="submitReturn()" 
              [disabled]="returnForm.invalid || isSubmitting || totalRefundAmount <= 0">
        <i class="fa fa-spinner fa-spin" *ngIf="isSubmitting"></i>
        <i class="fa fa-check-circle" *ngIf="!isSubmitting"></i>
        <span>{{ isSubmitting ? 'Traitement...' : 'Confirmer le Remboursement' }}</span>
      </button>
    </div>
  </div>
  <!-- Custom Confirmation Dialog -->
  <app-confirmation-dialog
    [isVisible]="isConfirmVisible"
    [title]="confirmTitle"
    [message]="confirmMessage"
    [type]="confirmType"
    [confirmText]="confirmBtnText"
    (confirm)="handleConfirm()"
    (cancel)="handleCancel()"
    (close)="isConfirmVisible = false">
  </app-confirmation-dialog>
</div>

